import React from "react";
// import "./index.scss";

export default function NotAuthorized({ icon, title }) {
  return (
    <div className="page-content w-100">
      <div className="white-space d-flex justify-content-center">
        <div className="white-c">
          <div className="soon align-self-end"> Not Authorized</div>
          <span className="soon-detail align-self-end">
            For additional details contact: support@easyshul.com
          </span>
        </div>
      </div>
    </div>
  );
}
